// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { getbannersEditDetails, getbannersCollections, putbannersFormData } from '@/services/decoration.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      modifyData: {},
      collapseLength: [],
      formData: jsonData.formData
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      getbannersCollections().then(res => {
        if (res.status === 200) {
          this.formData[0].createDateItem[5].options = res.data.group_names
          this.formData[0].createDateItem[10].options = res.data.models
          this.formData[0].createDateItem[4].options = res.data.platforms
        }
      })
      getbannersEditDetails(this.$route.params.id).then(res => {
        if (res.status === 200) {
          this.modifyData = res.data.banner
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    formSubmit (data) {
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        banner: obj
      }
      Object.keys(params.banner).forEach(res => {
        if (typeof params.banner[res] === 'boolean') {
          if (params.banner[res] === true) params.banner[res] = '1'
          if (params.banner[res] === false) params.banner[res] = '0'
        }
      })
      putbannersFormData(params, this.$route.params.id).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'bannerList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
